import styled, { css } from 'styled-components'
import { fadeIn, slideInFromLeft, fadeInUp, pulse } from './Animations'

export const LayoutContainer = styled.div`
  background-color: white;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 0.9em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 0.9em;
  }
`

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: sticky;
  top: -10px;
  z-index: 3;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`

export const ContentContainer = styled.div`
  background-color: white;
  min-height: 60vh;
`
 
export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FooterContainer = styled.div`
  color: white;
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(0, 0, 1, 1));
`

export const JoinTeamComponent = styled.div`
  background-color: #F2F2F2;
`

export const SectionsContainer = styled.div`
  background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(0, 0, 1, 1));
  width: 100%;
`

export const AboutContent = styled.div`

`

export const ContainerProduct = styled.div`
  display: flex;
  color: white;
  height: 90vh;

  @media (max-width: 550px) {
        /* Phones */
        flex-direction: column;
        height: auto;

      }

      @media (max-width: 1100px) {
        /* Tablets */
        flex-direction: column;
        height: auto;
      }
`;

export const EuphaWorldContainer = styled.div`
  height: 100%;
  width: 100%;
`


export const ContainerProducts = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  color: #0d1120;
`

export const ContentContainerEuphaWorld = styled.div`
  background-color: #89191a;
  padding: 7em 0 0em 0;
`

export const TitleEuphaWorld = styled.div`
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${slideInFromLeft} 1s ease-in-out;

  p:nth-child(1){
    font-size: 2rem;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
  }

  span{
    color: rgba(179, 179, 179, 1)
  }

  p:nth-child(2){
    margin-top: -0.5em;
    font-size: 2rem;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
  }

  p:nth-child(3){
    width: 50%;
  }
`

export const AnimatedComponent = styled.div`
  animation: ${fadeInUp} 1s ease-in-out;
`

export const ButtonMore = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 2em;
  padding-top: 1em;

  button{
    background-color: rgba(40, 44, 52, 1);
    color: rgb(255, 255, 255);
    border: 1px solid rgba(40, 44, 52, 1);
    padding: 10px 30px;
    border-radius: 30px;
    font-size: 0.9em;
    cursor: pointer;

    &:hover {
      background-color: rgba(234, 11, 42, 1);
      border: 1px solid rgba(234, 11, 42, 1);
      color: white;
    }
  }
`
